import { useMemo } from 'react';

import { useGetAvailableSelectionsQuery } from 'types/atlas-graphql';

import { type DamageSchemaFilterColumn, getDamageSchemaPrefetchSelections } from './utils';

type Props = {
  filteredInfo?: Record<string, unknown>;
  schemaColumns: DamageSchemaFilterColumn[];
  schemaId?: string;
};

type PrefetchQueryProps = {
  schemaId?: string;
  selections: ReturnType<typeof getDamageSchemaPrefetchSelections>[number];
};

const PrefetchQuery = ({ schemaId, selections }: PrefetchQueryProps) => {
  // Best-effort cache warmup; the dropdown performs its own query on a cache miss.
  useGetAvailableSelectionsQuery({
    variables: {
      ...(schemaId ? { schemaId } : {}),
      selections,
    },
    fetchPolicy: 'network-only',
  });

  return null;
};

export const DamageSchemaFilterSuggestionsPrefetch = ({
  filteredInfo,
  schemaColumns,
  schemaId,
}: Props) => {
  const selectionSets = useMemo(
    () =>
      getDamageSchemaPrefetchSelections({
        columns: schemaColumns,
        filteredInfo,
      }),
    [filteredInfo, schemaColumns]
  );

  return (
    <>
      {selectionSets.map(selections => (
        <PrefetchQuery
          key={JSON.stringify(selections)}
          schemaId={schemaId}
          selections={selections}
        />
      ))}
    </>
  );
};
